import classNames from 'classnames';
import { ReactNode } from 'react';

import { VerticalSpacing } from '../Spacing';
import { Heading } from '../Typography/Heading';

import s from './FormSection.module.scss';

export const FormSection = ({
  title,
  description,
  styleClassNames,
  spacing,
  children,
}: {
  title?: string | ReactNode;
  description?: string | ReactNode;
  styleClassNames?: string;
  spacing?: 1 | 2 | 3 | 4;
  children: ReactNode;
}) => (
  <VerticalSpacing spacing={4} className={s.formSection}>
    <div className={classNames('u-bg-white p-3 u-border-r-3', styleClassNames)}>
      <VerticalSpacing spacing={spacing ?? 2}>
        <div>
          {typeof title === 'string' ? <FormSectionTitle>{title}</FormSectionTitle> : title}
          {description && typeof description === 'string' ? <p className="u-fs-2">{description}</p> : description}
        </div>
        {children}
      </VerticalSpacing>
    </div>
  </VerticalSpacing>
);

export const FormSectionTitle = ({ children }: { children: ReactNode }) => (
  <Heading level={3} className="d-block">
    {children}
  </Heading>
);
